import React, { useState } from "react";
import axios from "axios";
import { FaCheckCircle, FaTimes } from "react-icons/fa";

const Form = () => {
  const clientKey = "awayhomezone";
  const formId = "Contact";
  const apiUrl = "https://7t0xfgk6y1.execute-api.eu-west-2.amazonaws.com/form";

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(null);
    setError(null);

    try {
      const response = await axios.post(apiUrl, {
        client: clientKey,
        formid: formId,
        name,
        email,
        message,
      });

      if (response.status === 200) {
        setSuccess("Your message has been sent successfully!");
        setName("");
        setEmail("");
        setMessage("");
      } else {
        setError("Something went wrong, please try again.");
      }
    } catch (err) {
      console.error(err);
      setError("Error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit}>
        <div>
          <label>Name</label>
          <input
            type="text"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Message</label>
          <textarea
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "Sending..." : "Submit"}
        </button>
      </form>

      {success && (
        <div className="success-message">
          <FaCheckCircle />
          {success}
        </div>
      )}

      {error && (
        <div className="error-message">
          <FaTimes />
          {error}
        </div>
      )}
    </div>
  );
};

export default Form;
